import * as React from "react";
import { LoaderScreen } from "@grandvisionhq/common";
const _OnlyOnClient = class _OnlyOnClient extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      onServer: true
    };
  }
  componentDidMount() {
    this.setState({ onServer: false });
  }
  render() {
    return this.state.onServer ? this.props.serverContent : this.props.children;
  }
};
_OnlyOnClient.defaultProps = {
  serverContent: /* @__PURE__ */ React.createElement(LoaderScreen, { height: 50 })
};
let OnlyOnClient = _OnlyOnClient;
export {
  OnlyOnClient
};
//# sourceMappingURL=OnlyOnClient.js.map
